import { useEffect, useState } from 'react';
import { cn } from '../utils/cn';
import sortDefaultIcon from '../assets/sort_default.svg';
import sortAscIcon from '../assets/sort_asc.svg';
import sortDescIcon from '../assets/sort_desc.svg';

const Sort = ({ 
  items = [], 
  onChange, 
  className, 
  defaultSortIndex = 0, 
  defaultDirection = 'desc' 
}) => {
  // Initialize with 'none' for all items except the default which should be the specified direction
  const [sortStates, setSortStates] = useState(
    items.map((_, index) => index === defaultSortIndex ? defaultDirection : 'none')
  );

  // Call onChange with the default selection on mount
  useEffect(() => {
    if (items.length > 0 && defaultSortIndex < items.length) {
      onChange?.(items[defaultSortIndex], defaultDirection);
    }
  }, []);

  const handleClick = (index) => {
    const newSortStates = items.map((_, i) => {
      if (i === index) {
        // Toggle between asc and desc only (no 'none' state)
        return sortStates[i] === 'desc' ? 'asc' : 'desc';
      }
      return 'none'; // Reset other items
    });
    
    setSortStates(newSortStates);
    onChange?.(items[index], newSortStates[index]);
  };

  return (
    <div className={cn(
      "h-9 bg-[#f4f4f4] rounded-[18px] inline-flex items-center",
      className
    )}>
      {items.map((item, index) => (
        <div key={item.label} className="flex items-center h-full">
          {index > 0 && <div className="w-px h-4 bg-[#dddddd]" />}
          <button
            onClick={() => handleClick(index)}
            className="h-full px-[18px] rounded-3xl flex items-center"
          >
            <div className="flex items-center gap-1.5">
              <div className="w-4 h-4 flex items-center justify-center">
                {sortStates[index] === 'none' && <img src={sortDefaultIcon} className='w-4 h-4' alt="default" />}
                {sortStates[index] === 'asc' && <img src={sortAscIcon} className='w-4 h-4' alt="ascending" />}
                {sortStates[index] === 'desc' && <img src={sortDescIcon} className='w-4 h-4' alt="descending" />}
              </div>
              <div className="text-[#111111] text-sm font-normal leading-[21px]">
                {item.label}
              </div>
            </div>
          </button>
        </div>
      ))}
    </div>
  );
};

export default Sort; 